<template>
    <div class="set-min-contain">
    <fansLive @getLive="getLive"></fansLive>
     <div class="top_box">
      <div class="txt_1" :class="queryData.sort === 'views' ? 'color_flow' : ''" @click="sort('views')">
        总流量
        <img src="https://s6.bihukankan.com/img/1694420085Group 3532.svg" alt="" v-if="queryData.sort === 'views'">
        <img src="https://s6.bihukankan.com/img/1694420142Group 3532 (1).svg" alt="" v-else>
      </div>
      <div class="txt_2" :class="queryData.sort === 'avgViews' ? 'color_flow' : ''" @click="sort('avgViews')">
        分钟流量
        <img src="https://s6.bihukankan.com/img/1694420085Group 3532.svg" alt="" v-if="queryData.sort === 'avgViews'">
        <img src="https://s6.bihukankan.com/img/1694420142Group 3532 (1).svg" alt="" v-else>
      </div>
      <div class="txt_3">直播日期</div>
      <van-dropdown-menu active-color="#2877FF">
        <van-dropdown-item title-class="custorm" @change="loadAgain" v-model="dropdownValue" :options="dropdownDay" />
      </van-dropdown-menu>
     </div>
      <div class="set-min-contain">
        <van-list v-model="loading" :finished="finished" :finished-text="finishedText"  @load="query">
          <search tab="anchor"></search>
          <List :info="item" :index="index + 1" v-for="(item,index) in info.data" :key="index"/>
        </van-list>
        <LoginOrPayView v-if="!isVip && finished" vip-text="升级版本权益后<br/>即可查看更多数据和使用更多功能"/>
        <More />
      </div>
  
    </div>
  </template>
  
  <script>
  import moment from 'moment';
  import List from './list.vue'
  import fansLive from "@/modules/carrierList/fansLive.vue"
  import search from '@/modules/toSearch/tosearch.vue'
  const page = {
          pageNum: 1,
          pageSize: 25,
          sort: 'sales',//排序方式
          order: 'desc',
          fans:'',//粉丝区间
          liveType:''//直播类型
}
  export default {
    components: { List,fansLive,search },
    data() {
      return {
        count: 0,
        loading:true,
        queryData: page,
        info: {},
        obj:{},
        dropdownValue:0
      }
    },
    computed:{
      finished(){ return this.info?.paging?.count === this.info?.data?.length },
      isVip: (_this = this) => (_this.$store.state.userLevel && _this.$store.state.userLevel < 94),
      finishedText: ( _this = this) => ( !_this.isVip ? '升级权益查看更多数据' : '没有更多了'),
      dropdownDay() {
      const now = new moment();
      const now_new = new moment();
      let before6 = 0
      // 6点前不显示昨天选项
      if (now.hours() < 6) {
        now.subtract(1, 'days');
        now_new.subtract(1, 'days');
        before6 = 1
      }
      return [...new Array(7)].map((ele, index) => {
        return {
          text: now.subtract(1, 'days').format('MM-DD'),
          newtext: now_new.subtract(1, 'days').format('YYYYMMDD'),
          value: index,
          timeMode: 14
        };
      });
    },
    },
    mounted() {
      this.loadAgain()
    },
    methods: {
      sort(val) {
        if (this.$store.state.userLevel && this.$store.state.userLevel <= 100) {
          this.queryData.sort = val
          this.loading = true
          this.count = 0
          this.info = {}
          this.queryData.pageNum = 1
          this.query();
      } else {
        setTimeout(() => {
          this.$store.commit('WRITEOVERLAYSHOW',  { status: true, textChange: 'carrierList' });
        }, 500);
      }
      },
        getLive(val) {
          if (this.$store.state.userLevel && this.$store.state.userLevel <= 100) {
            this.obj = val
            this.loading = true
            this.count = 0
            this.info = {}
            this.queryData.pageNum = 1
            this.query();
      } else {
        setTimeout(() => {
          this.$store.commit('WRITEOVERLAYSHOW',  { status: true, textChange: 'carrierList' });
        }, 500);
      }
           
        },
      loadAgain(val) {
        if ((this.$store.state.userLevel && this.$store.state.userLevel <= 100) || !this.count) {
          const data = this.dropdownDay[this.dropdownValue]
          this.queryData = {
          ...this.queryData,
          pageNum: 1,
          time: data.newtext,
          timeMode:data.timeMode
        };
        this.loading = true
        this.count = 0
        this.info = {}
        this.query();
      } else {
        setTimeout(() => {
          this.$store.commit('WRITEOVERLAYSHOW',  { status: true, textChange: 'carrierList' });
        }, 500);
      }
      },
      parse(obj){
        this.count = obj.paging.count
        if(this.queryData.index === 1){
          return obj
        }else{
          return {
            paging:obj.paging,
            data:this.info?.data? this.info.data.concat(obj.data) : obj.data
          }
        }
      },
      query() {
        this.$get({
          road: 'liveFlow',
          params: {...this.queryData,...this.obj},
          version: 'v22'
        })
          .then(res => {
            this.queryData.pageNum ++
            this.loading = false
            this.info = this.parse(res.data)
          })
      }
    },
  }
  </script>
  
  <style lang="less" scoped>
         .color_flow {
          color:#4189ec !important;
        }
  .top_box {
    background-color: #fff;
    display: flex;
    height: 60px;
    align-items: center;
    font-size: 14px;
    color: #696D75;
    .txt_1 {
      margin-left: 12px;
      margin-right: 20px;
      img {
        width: 16px;
        height: 16px;
        position: relative;
        top: 3px;
      }
    }
    .txt_2 {
      margin-right: 50px;
      img {
        width: 16px;
        height: 16px;
        position: relative;
        top: 3px;
      }
    }
    .txt_3 {
      margin-right: 26px;
    }
  }
  /deep/.van-dropdown-menu__item {
    height: 100% !important;
    line-height: 100% !important;
}
/deep/.van-dropdown-menu {
    height: 100% !important;
}
/deep/.van-dropdown-menu__bar {
    box-shadow: none !important;
    height: 100% !important;
}
/deep/.van-ellipsis {
    font-size: 14px;
}
  </style>
  